import script from "./PackageDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageDetails.vue?vue&type=script&setup=true&lang=js"

import "./PackageDetails.vue?vue&type=style&index=0&id=53f5b738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f5b738"]])

export default __exports__